import React from 'react';
import SafeIcon from '../common/SafeIcon';
import { FiClock, FiBook, FiTarget } from 'react-icons/fi';

const OrbitCard = ({ item }) => {
  const isExam = item.type === 'exam';
  
  return (
    <div className="glass-panel p-4 rounded-2xl min-w-[260px] relative overflow-hidden group hover:border-[#eaff00] transition-colors duration-300 flex-shrink-0 cursor-pointer">
      {/* Decorative orbit arcs */}
      <div className="absolute -right-8 -top-8 w-24 h-24 orbit-ring group-hover:border-[#eaff00]/40 transition-colors duration-500"></div>
      <div className="absolute -right-12 -top-12 w-32 h-32 orbit-ring group-hover:border-[#eaff00]/20 transition-colors duration-500"></div>

      <div className="flex justify-between items-start mb-3">
        <span className={`text-xs font-bold px-2 py-1 rounded-full ${isExam ? 'bg-red-500/20 text-red-400' : 'bg-[#eaff00]/10 text-[#eaff00]'}`}>
          {item.course}
        </span>
        <SafeIcon icon={isExam ? FiTarget : FiBook} className={isExam ? 'text-red-400' : 'text-[#eaff00]'} />
      </div>
      
      <h3 className="font-semibold text-slate-100 mb-1 truncate pr-8">{item.title}</h3>
      
      <div className="flex items-center text-xs text-slate-400 mb-4">
        <SafeIcon icon={FiClock} className="mr-1.5" />
        {item.due}
      </div>

      <div className="w-full bg-[#0b0c1b] rounded-full h-1.5 mb-1">
        <div 
          className={`h-1.5 rounded-full ${isExam ? 'bg-red-400' : 'bg-[#eaff00]'}`} 
          style={{ width: `${item.progress}%` }}
        ></div>
      </div>
      <div className="text-[10px] text-right text-slate-500">{item.progress}% Complete</div>
    </div>
  );
};

export default OrbitCard;